import PocketBase from 'pocketbase';

const pb = new PocketBase('https://roulezpropre.infocolab.online');

export default pb;
